module.exports = __webpack_public_path__ + "static/media/cloud_upload.e9473c3a.svg";